import React from "react";

const VARIANT_STYLES = {
    indigo: "bg-indigo-50 text-indigo-600 ring-indigo-100",
    violet: "bg-violet-50 text-violet-600 ring-violet-100",
    emerald: "bg-emerald-50 text-emerald-600 ring-emerald-100",
    amber: "bg-amber-50 text-amber-600 ring-amber-100",
};

const DashboardStatCard = ({
    label,
    value,
    icon: Icon,
    variant = "indigo",
    onClick,
}) => {
    const iconStyle = VARIANT_STYLES[variant] || VARIANT_STYLES.indigo;
    const isInteractive = typeof onClick === "function";
    const CardElement = isInteractive ? "button" : "article";

    return (
        <CardElement
            {...(isInteractive ? { type: "button", onClick } : {})}
            aria-label={isInteractive ? label : undefined}
            className={[
                "min-w-0 rounded-2xl border border-slate-200 bg-white p-3 text-left shadow-sm sm:p-4",
                isInteractive
                    ? "w-full cursor-pointer transition hover:-translate-y-0.5 hover:border-indigo-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:ring-offset-2"
                    : "",
            ]
                .filter(Boolean)
                .join(" ")}
        >
            <div className="flex items-center gap-2.5 sm:gap-3">
                {Icon && (
                    <span
                        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${iconStyle}`}
                    >
                        <Icon
                            size={20}
                            aria-hidden="true"
                        />
                    </span>
                )}

                <div className="min-w-0">
                    <p className="text-xs font-semibold text-slate-700 sm:text-sm">
                        {label}
                    </p>
                    <p className="mt-1 text-xl font-bold text-slate-900 sm:text-2xl">
                        {value ?? "--"}
                    </p>
                </div>
            </div>
        </CardElement>
    );
};

export default DashboardStatCard;
